export const config = {
    trackType: '百度智能云千帆大模型平台',
    layout: 'wenxin',
    page: 'wenxin',
};

export const headerSdk = {
    logoInfo: {
        link: 'https://qianfan.cloud.baidu.com',
        url: 'https://appbuilder-portal.cdn.bcebos.com/image/ab_logo.png',
    },
    menuList: [
        {
            title: '大模型服务与开发平台ModelBuilder',
            link: 'https://console.bce.baidu.com/qianfan/overview',
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': '大模型服务与开发平台ModelBuilder',
            },
        },
        {
            title: '大模型应用开发平台AppBuilder',
            link: 'https://console.bce.baidu.com/ai_apaas/dialogHome',
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': '大模型应用开发平台AppBuilder',
            },
        },
        {
            title: 'BML全功能AI开发平台',
            link: 'https://console.bce.baidu.com/bml/',
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': 'BML全功能AI开发平台',
            },
        },
        {
            title: 'AI开放平台',
            link: 'https://ai.baidu.com/',
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': 'AI开放平台',
            },
        },
        {
            title: 'AI速搭',
            link: 'https://aisuda.baidu.com/',
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': 'AI速搭',
            },
        },
        {
            title: '千帆社区',
            link: 'https://cloud.baidu.com/qianfandev?track=cloudweb',
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': '千帆社区',
            },
        },
    ],
};

export const header = {
    logo: require('assets/wenxin/logo.png').default,
    navList: [
        {
            text: '大模型服务与开发平台ModelBuilder',
            // link: 'https://qianfan.cloud.baidu.com/modelbuilder',
            link: 'https://console.bce.baidu.com/qianfan/overview',
            id: 0,
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': '大模型服务与开发平台ModelBuilder',
            },
        },
        {
            text: '大模型应用开发平台AppBuilder',
            // link: 'https://qianfan.cloud.baidu.com/appbuilder',
            link: 'https://console.bce.baidu.com/ai_apaas/dialogHome',
            id: 1,
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': '大模型应用开发平台AppBuilder',
            },
        },
        {
            text: 'BML全功能AI开发平台',
            // link: 'https://cloud.baidu.com/product/bml',
            link: 'https://console.bce.baidu.com/bml/',
            id: 2,
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': 'BML全功能AI开发平台',
            },
        },
        {
            text: 'AI开放平台',
            link: 'https://ai.baidu.com/',
            id: 3,
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': 'AI开放平台',
            },
        },
        {
            text: 'AI速搭',
            link: 'https://aisuda.baidu.com/',
            id: 4,
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': 'AI速搭',
            },
        },
        {
            text: '千帆社区',
            link: 'https://cloud.baidu.com/qianfandev?track=cloudweb',
            id: 5,
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': '文字链',
                'data-track-value': '千帆社区',
            },
        },
    ],
    buttonGroupRight: [
        {
            text: '登录',
            href: 'https://login.bce.baidu.com/',
            class: 'login-btn',
            id: 1,
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': 'EMPTY',
                'data-track-value': '登录',
            },
        },
        {
            text: '注册',
            href: 'https://login.bce.baidu.com/new-reg?tpl=bceplat&amp;from=portal',
            class: 'regist-btn',
            id: 2,
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': 'EMPTY',
                'data-track-value': '注册',
            },
        },
        {
            text: require('assets/qianfan/zhinengyun.svg').default,
            href: 'https://cloud.baidu.com/',
            type: 'primary',
            class: 'back-btn',
            id: 0,
            trackInfo: {
                'data-track-category': '新官网PC-吸顶',
                'data-track-name': 'EMPTY',
                'data-track-value': '前往百度智能云',
            },
        },
    ],
};
export const footerSdk = {
    columns: [
        [
            {
                text: '关于我们',
            },
            {
                text: '百度智能云千帆大模型平台，企业级一站式大模型与AI原生应用开发及服务平台',
            },
            {
                text: '文心大模型企业级服务唯一入口，并且涵盖丰富的第三方开源大模型',
            },
            {
                text: '提供先进的生成式AI生产及应用全流程开发工具链和整套开发环境',
            },
            {
                text: '从数据管理到服务云端部署，完备的流程助力各行业生成式AI应用需求落地',
            },
        ],
        [
            {
                text: '社区与资源',
            },
            {
                text: '千帆社区',
                link: 'https://cloud.baidu.com/qianfandev',
            },
            {
                text: '专家服务',
                link: 'https://cloud.baidu.com/doc/support/index.html#expert',
            },
            {
                text: '文档中心',
                link: 'https://cloud.baidu.com/doc/index.html',
            },
            {
                text: 'SDK中心',
                link: 'https://cloud.baidu.com/doc/Developer/index.html',
            },
            {
                text: 'API平台',
                link: 'https://cloud.baidu.com/doc/API/index.html',
            },
            {
                text: '培训与认证',
                link: 'https://cloud.baidu.com/doc/support/index.html#training',
            },
        ],
        [
            {
                text: '服务与支持',
            },
            {
                text: '支持热线：400-920-8999转1',
            },
            {
                text: '我的工单',
                link: 'https://console.bce.baidu.com/ticket/#/ticket/list',
            },
            {
                text: '合作咨询',
                link: 'https://cloud.baidu.com/znzs/pre-sale#/znzs/presale/https%253A%252F%252Fcloud.baidu.com%252Fsupport%252Fplan.html',
            },
        ],
    ],
    qrCodes: {
        title: '关注我们，获取最新产品动态',
        list: [
            {
                url: 'https://now.bdstatic.com/store/v2/6a045a1/easy-landing/525dcef/product/rcodea800cf.png',
                text: '百度智能云微信公众号',
            },
        ],
    },
    copyRight: [
        {
            text: '© 2024 Baidu 使用百度前必读',
        },
        {
            text: '京ICP证030173号-1',
        },
    ],
};

export const footer = {
    about: {
        title: '关于我们',
        des: [
            {
                text: '百度智能云千帆大模型平台，企业级一站式大模型与AI原生应用开发及服务平台',
                id: 0,
            },
            {
                text: '文心大模型企业级服务唯一入口，并且涵盖丰富的第三方开源大模型',
                id: 1,
            },
            {
                text: '提供先进的生成式AI生产及应用全流程开发工具链和整套开发环境',
                id: 2,
            },
            {
                text: '从数据管理到服务云端部署，完备的流程助力各行业生成式AI应用需求落地',
                id: 3,
            },
        ],
    },
    resources: {
        title: '社区与资源',
        list: [
            {
                id: 0,
                text: '千帆社区',
                href: 'https://cloud.baidu.com/qianfandev',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '千帆社区',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '千帆社区',
                },
            },
            {
                id: 1,
                text: '专家服务',
                href: 'https://cloud.baidu.com/doc/support/index.html#expert',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '专家服务',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '专家服务',
                },
            },
            {
                id: 2,
                text: '文档中心',
                href: 'https://cloud.baidu.com/doc/index.html',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '文档中心',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '文档中心',
                },
            },
            {
                id: 3,
                text: 'SDK中心',
                href: 'https://cloud.baidu.com/doc/Developer/index.html',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-banner',
                    'data-track-name': '主按钮',
                    'data-track-value': 'SDK中心',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-banner',
                    'data-track-name': '主按钮',
                    'data-track-value': 'SDK中心',
                },
            },
            {
                id: 4,
                text: 'API平台',
                href: 'https://cloud.baidu.com/doc/API/index.html',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': 'API平台',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': 'API平台',
                },
            },
            {
                id: 5,
                text: '培训与认证',
                href: 'https://cloud.baidu.com/doc/support/index.html#training',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '培训与认证',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '社区与资源',
                    'data-track-value': '培训与认证',
                },
            },
        ],
    },
    service: {
        title: '服务与支持',
        list: [
            {
                id: 0,
                text: '支持热线：400-920-8999转1',
            },
            {
                id: 1,
                text: '我的工单',
                href: 'https://console.bce.baidu.com/ticket/#/ticket/list',
                // href: 'https://console.bce.baidu.com/support/?u=ModelBuilder#/ticket/#/ticket/create?productId=279',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '服务与支持',
                    'data-track-value': '我的工单',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '服务与支持',
                    'data-track-value': '我的工单',
                },
            },
            {
                id: 2,
                text: '合作咨询',
                href: 'https://cloud.baidu.com/znzs/pre-sale#/znzs/presale/https%253A%252F%252Fcloud.baidu.com%252Fsupport%252Fplan.html',
                trackInfo: {
                    'data-track-category': '千帆产品页PC-底部导航',
                    'data-track-name': '服务与支持',
                    'data-track-value': '合作咨询',
                },
                trackInfo_m: {
                    'data-track-category': '千帆产品页wise-底部导航',
                    'data-track-name': '服务与支持',
                    'data-track-value': '合作咨询',
                },
            },
        ],
    },
    qrCode: require('assets/wenxin/rcode.png').default,
};

export const banner = {
    slideLists: [
        {
            id: 0,
            className: 'banner-swiper0',
            frameworkIcon: require('assets/qianfan/banner-framework.png').default,
            noticeList: [
                {
                    id: 0,
                    tag: 'NEW',
                    desc: '百度文心大模型4.5系列正式开源！',
                    link: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/list',
                    trackInfo: {
                        'data-track-category': '新官网PC-banner',
                        'data-track-name': '文字链',
                        'data-track-value': '百度文心大模型4.5系列正式开源！',
                    },
                },
            ],
            title: '千帆大模型平台',
            title_ipad: '千帆大模型平台',
            titleFs: '',
            title_m: (
                <>
                    千帆
                    <br />
                    大模型平台
                </>
            ),
            desc: '企业级一站式大模型与AI原生应用开发及服务平台',
            btns: [
                {
                    text: '模型开发及服务',
                    href: 'https://cloud.baidu.com/product-s/qianfan_modelbuilder',
                    cn: 'banner-btn btn-gradual',
                    trackInfo: {
                        'data-track-category': '新官网PC-banner-qf',
                        'data-track-name': '按钮',
                        'data-track-value': '模型开发及服务',
                    },
                },
                {
                    text: <span className="fs-gradient">应用开发</span>,
                    href: 'https://qianfan.cloud.baidu.com/appbuilder',
                    cn: 'banner-btn btn-secondary',
                    trackInfo: {
                        'data-track-category': '新官网PC-banner-qf',
                        'data-track-name': '按钮',
                        'data-track-value': '应用开发',
                    },
                },
            ],
        },
        {
            id: 1,
            className: 'banner-swiper5',
            // className: 'banner-swiper1',
            frameworkIcon: require('assets/qianfan/banner-framework-mb.png').default,
            // noticeList: [
            //     {
            //         id: 0,
            //         tag: 'HOT',
            //         desc: 'iRAG图片生成、图生视频组件重磅上线，即刻解锁创作新姿势。',
            //         link: 'https://console.bce.baidu.com/ai_apaas/componentCenter',
            //         trackInfo: {
            //             'data-track-category': '新官网PC-吸顶',
            //             'data-track-name': '文字链',
            //             'data-track-value': 'iRAG图片生成、图生视频组件重磅上线，即刻解锁创作新姿势。',
            //         },
            //     },
            // ],
            title: '文心大模型4.5系列正式开源',
            titleFs: 'fs-sm', // className for title fontSize 'fs-sm'
            title_ipad: (
                <>
                    文心大模型4.5系列
                    <br />
                    正式开源
                </>
            ),
            title_m: (
                <>
                    文心大模型4.5系列
                    <br />
                    正式开源
                    {/* <span className="banner-title-gradual"></span> */}
                </>
            ),
            desc: <>千帆大模型平台支持开源模型API服务，无需本地部署，使用成本更低</>,
            btns: [
                {
                    text: '立即使用',
                    href: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/list',
                    cn: 'banner-btn btn-gradual',
                    trackInfo: {
                        'data-track-category': '新官网PC-banner',
                        'data-track-name': '按钮',
                        'data-track-value': '立即使用',
                    },
                },
            ],
        },
        {
            id: 2,
            className: 'banner-swiper2',
            frameworkIcon: require('assets/qianfan/banner-framework-ab.png').default,
            noticeList: [
                {
                    id: 0,
                    tag: 'HOT',
                    desc: '百度智能云应用开发平台MCP广场全新上线',
                    link: 'https://console.bce.baidu.com/ai_apaas/mcpServerCenter',
                    trackInfo: {
                        'data-track-category': '新官网PC-吸顶',
                        'data-track-name': '文字链',
                        'data-track-value': '百度智能云应用开发平台MCP广场全新上线',
                    },
                },
            ],
            title: (
                <>
                    千帆应用开发平台“智能体Pro”
                    <br />
                    全新上线
                </>
            ),
            title_ipad: (
                <>
                    千帆应用开发平台“智能体Pro”
                    <br />
                    全新上线
                </>
            ),
            titleFs: 'fs-sm',
            title_m: (
                <>
                    千帆应用开发平台“智能体Pro”
                    <br />
                    全新上线
                </>
            ),
            desc: '面向慢思考场景，支持低代码配置的方式创建“智能体Pro”应用',
            btns: [
                {
                    text: '立即体验',
                    href: 'https://console.bce.baidu.com/ai_apaas/appCenter',
                    cn: 'banner-btn btn-gradual',
                    trackInfo: {
                        'data-track-category': '新官网PC-banner-qf',
                        'data-track-name': '按钮',
                        'data-track-value': '立即体验',
                    },
                },
            ],
        },
    ],
    cardList: [
        {
            icon: require('assets/qianfan/banner-card-icon1.png').default,
            title: '应用开发服务',
            id: 'appBuilder',
            offset: 80,
            content: 'Agent智能体、RAG知识问答、工作流编排',
            trackInfo: {
                'data-track-category': '新官网页PC-banner',
                'data-track-name': '横幅第1个',
                'data-track-value': '应用开发服务',
            },
        },
        {
            icon: require('assets/qianfan/banner-card-icon2.png').default,
            title: '模型训练与推理',
            id: 'application',
            offset: 80,
            content: '大模型推理、大模型精调、全功能AI开发',
            trackInfo: {
                'data-track-category': '新官网页PC-banner',
                'data-track-name': '横幅第2个',
                'data-track-value': '模型训练与推理',
            },
        },
        {
            icon: require('assets/qianfan/banner-card-icon3.png').default,
            title: '场景最佳实践',
            id: 'practiceForModel',
            offset: 80,
            content: '模型精调样板间、Prompt样板间、应用场景样板间',
            trackInfo: {
                'data-track-category': '新官网页PC-banner',
                'data-track-name': '横幅第3个',
                'data-track-value': '场景最佳实践',
            },
        },
        {
            icon: require('assets/qianfan/banner-card-icon4.png').default,
            title: 'AI开发资源',
            id: 'qfResource',
            offset: 80,
            content: '千帆社区、Github、Cookbook',
            trackInfo: {
                'data-track-category': '新官网页PC-banner',
                'data-track-name': '横幅第4个',
                'data-track-value': 'AI开发资源',
            },
        },
    ],
};

export const serviceMode = {
    title: '多种服务模式满足企业级标准化交付',
    titleMobile: (
        <>
            多种服务模式
            <br />
            满足企业级标准化交付
        </>
    ),
    grayIcon: require('assets/qianfan/contact-us.png').default,
    whiteIcon: require('assets/qianfan/contact-us-white.png').default,
    content: {
        left: {
            title: '公有云',
            content: '适合需要快速获取定制大模型服务的企业',
            desc: [
                '公共资源服务推理，超高性价比',
                '私有资源服务托管，保障请求并发',
                '7 × 24 小时工单支持，在线技术服务',
            ],
            btnList: [
                {
                    id: 0,
                    text: (
                        <>
                            大模型服务与开发平台
                            <br />
                            ModelBuilder
                        </>
                    ),
                    // link: 'https://qianfan.cloud.baidu.com/modelbuilder',
                    link: 'https://console.bce.baidu.com/qianfan/overview',
                    trackInfo: {
                        'data-track-category': '新官网PC-多种服务模式满足企业级标准化交付',
                        'data-track-name': '公有云',
                        'data-track-value': '大模型服务与开发平台ModelBuilder',
                    },
                    trackInfo_m: {
                        'data-track-category': '新官网wise-多种服务模式满足企业级标准化交付',
                        'data-track-name': '公有云',
                        'data-track-value': '大模型服务与开发平台ModelBuilder',
                    },
                },
                {
                    id: 1,
                    text: (
                        <>
                            大模型应用开发平台
                            <br />
                            AppBuilder
                        </>
                    ),
                    // link: 'https://qianfan.cloud.baidu.com/appbuilder',
                    link: 'https://console.bce.baidu.com/ai_apaas/dialogHome',
                    trackInfo: {
                        'data-track-category': '新官网PC-多种服务模式满足企业级标准化交付',
                        'data-track-name': '公有云',
                        'data-track-value': '大模型应用开发平台AppBuilder',
                    },
                    trackInfo_m: {
                        'data-track-category': '新官网wise-多种服务模式满足企业级标准化交付',
                        'data-track-name': '公有云',
                        'data-track-value': '大模型应用开发平台AppBuilder',
                    },
                },
                {
                    id: 2,
                    text: (
                        <>
                            全功能AI开发平台
                            <br />
                            BML
                        </>
                    ),
                    // link: 'https://cloud.baidu.com/product/bml',
                    link: 'https://console.bce.baidu.com/bml/',
                    trackInfo: {
                        'data-track-category': '新官网PC-多种服务模式满足企业级标准化交付',
                        'data-track-name': '公有云',
                        'data-track-value': '全功能AI开发平台BML',
                    },
                    trackInfo_m: {
                        'data-track-category': '新官网wise-多种服务模式满足企业级标准化交付',
                        'data-track-name': '公有云',
                        'data-track-value': '全功能AI开发平台BML',
                    },
                },
            ],
        },
        right: [
            {
                id: 0,
                title: '私有化',
                desc: '适合对数据私密性和控制性要求较高的企业',
                btn: {
                    text: '联系我们',
                    link: 'https://cloud.baidu.com/survey/qianfansyhzx.html',
                    trackInfo: {
                        'data-track-category': '新官网PC-多种服务模式满足企业级标准化交付',
                        'data-track-name': '私有化',
                        'data-track-value': '联系我们',
                    },
                    trackInfo_m: {
                        'data-track-category': '新官网wise-多种服务模式满足企业级标准化交付',
                        'data-track-name': '私有化',
                        'data-track-value': '联系我们',
                    },
                },
            },
            {
                id: 1,
                title: '软硬一体',
                desc: '适合需要高可用且开箱即用大模型服务的企业',
                btn: {
                    text: '联系我们',
                    link: 'https://cloud.baidu.com/survey/qianfansyhzx.html',
                    trackInfo: {
                        'data-track-category': '新官网PC-多种服务模式满足企业级标准化交付',
                        'data-track-name': '软硬一体',
                        'data-track-value': '联系我们',
                    },
                    trackInfo_m: {
                        'data-track-category': '新官网wise-多种服务模式满足企业级标准化交付',
                        'data-track-name': '软硬一体',
                        'data-track-value': '联系我们',
                    },
                },
            },
        ],
    },
};

export const moreModelServices = {
    title: '更多大模型生态服务',
    list: [
        {
            id: 1,
            title: 'AI开放平台',
            desc: '提供丰富领先的AI基础能力，助力企业高效构建上层智能化业务应用',
            href: 'https://ai.baidu.com',
            hrefText: '前去了解',
            trackInfo: {
                'data-track-category': '千帆产品页PC-大模型生态服务',
                'data-track-name': '前往AI开放平台',
                'data-track-value': '前去了解',
            },
        },
        {
            id: 2,
            title: 'AI速搭',
            desc: 'AI速搭融合大模型，让应用开发过程更简单，开发的应用更智能',
            href: 'https://aisuda.baidu.com/',
            hrefText: '前去了解',
            trackInfo: {
                'data-track-category': '千帆产品页PC-大模型生态服务',
                'data-track-name': '前往AI速搭',
                'data-track-value': '前去了解',
            },
        },
        {
            id: 3,
            title: '增值服务',
            desc: '提供全栈的大模型服务，帮助企业实现AI应用落地与业务收益',
            href: 'https://cloud.baidu.com/product/llmservice.html',
            hrefText: '前去了解',
            trackInfo: {
                'data-track-category': '千帆产品页PC-大模型生态服务',
                'data-track-name': '前往增值服务',
                'data-track-value': '前去了解',
            },
        },
        {
            id: 4,
            title: '数据服务',
            desc: '提供一体化AI数据服务，加速AI原生应用的研发与持续优化',
            href: 'https://cloud.baidu.com/product/dcs.html',
            hrefText: '前去了解',
            trackInfo: {
                'data-track-category': '千帆产品页PC-大模型生态服务',
                'data-track-name': '前往数据服务',
                'data-track-value': '前去了解',
            },
        },
    ],
};
const DOC = process.env.API_DOC;
export const model = [
    {
        name: 'ERNIE X1 Turbo',
        icon: require('assets/wenxin/ernie-bot.png').default,
        type: '',
        label: ['百度自研', '深度推理'],
        tag: '热门',
        tagClass: 'performance',
        desc: 'ERNIE X1 Turbo具备更长的思维链，更强的深度思考能力，进一步增强了多模态和工具调用能力，擅长文学创作、逻辑推理等',
        desc_m: '',
        support: '支持部署调用',
        onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/DeepSeek/ERNIE-X1-Turbo-32K',
        doc: DOC,
        // learnMore: 'https://console.bce.baidu.com/qianfan/modelcenter/model/buildIn/detail/am-an73qfuiy92d'
    },
    {
        name: 'ERNIE 4.5 Turbo VL',
        icon: require('assets/wenxin/ernie-bot.png').default,
        // brand: ['百度'],
        type: '',
        label: ['百度自研', '多模态'],
        tag: '热门',
        tagClass: 'performance',
        // tagClass: 'flagship',
        desc: '文心一言大模型全新版本，图片理解、创作、翻译、代码等能力显著提升，首次支持32K上下文长度，首Token时延显著降低',
        desc_m: '',
        support: '支持部署调用',
        onlineTest:
            'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/NativeMultimodal/ERNIE-4.5-Turbo-VL-32K',
        doc: DOC,
    },
    {
        name: 'ERNIE 4.5 Turbo',
        icon: require('assets/wenxin/ernie-bot.png').default,
        label: ['百度自研', '文本生成'],
        type: '',
        tag: '热门',
        tagClass: 'performance',
        // tagClass: 'special',
        desc: '在去幻觉、逻辑推理和代码能力等方面也有着明显增强。对比文心4.5，速度更快、价格更低',
        desc_m: '',
        onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/LLM/ERNIE-4.5-Turbo-32K',
        doc: DOC,
    },
    {
        name: 'ERNIE 4.5',
        icon: require('assets/wenxin/ernie-bot.png').default,
        type: '',
        label: ['百度自研', '多模态'],
        tag: '热门',
        tagClass: 'performance',
        desc: '百度自主研发的新一代原生多模态基础大模型，通过多个模态联合建模实现协同优化，多模态理解能力优秀',
        desc_m: '',
        support: '支持部署调用',
        onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/LLM/ERNIE-4.5-8K-Preview',
        doc: DOC,
    },
    {
        name: 'ERNIE 4.0 Turbo',
        icon: require('assets/wenxin/ernie-bot.png').default,
        type: '旗舰级通用模型',
        label: ['文本生成'],
        tag: '旗舰级',
        tagClass: 'flagship',
        desc: '对比ERNIE 4.0，输出更长，时延更短。在文本创作和知识问答等常见任务上效果更优，回复的格式化更优',
        desc_m: '',
        support: '支持部署调用',
        onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-4.0-Turbo-8K',
        doc: DOC,
    },
    {
        name: 'ERNIE Speed Pro',
        icon: require('assets/wenxin/ernie-bot.png').default,
        label: ['支持精调', '通用场景'],
        type: '',
        tag: '主力级',
        tagClass: 'special',
        desc: '最好的可精调基座模型，参数规模比ERNIE Lite更高，在垂直场景基础上，支持行业通用大模型持续预训练或精调',
        desc_m: '最好的可精调基座模型，参数多于ERNIE Lite，支持行业通用大模型持续预训练或精调',
        onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/ERNIE-Speed-8K',
        doc: DOC,
    },
    {
        name: 'DeepSeek-R1',
        icon: require('assets/wenxin/deepseek-icon.png').default,
        label: ['第三方模型', '文本生成'],
        type: '',
        tag: '全新',
        tagClass: 'flagship',
        desc: 'DeepSeek-R1-250528上线，强化学习驱动，具备复杂逻辑推理与深度上下文理解能力，支持多领域任务的高效处理（如数学、代码及自然语言推理）',
        desc_m: 'DeepSeek-R1-250528上线，强化学习驱动，具备复杂逻辑推理与深度上下文理解能力，支持多领域任务的高效处理（如数学、代码及自然语言推理）',
        onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/LLM/DeepSeek-R1',
        doc: DOC,
    },
    {
        name: 'DeepSeek-V3',
        icon: require('assets/wenxin/deepseek-icon.png').default,
        label: ['第三方模型', '文本生成'],
        type: '',
        tag: '热门',
        tagClass: 'performance',
        desc: '强大的混合专家（MoE）语言模型，在百科知识、数学推理等多项任务上优势突出，评测成绩在主流榜单中位列开源模型榜首',
        desc_m: '',
        onlineTest: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest/LLM/DeepSeek-V3',
        doc: DOC,
    },
];

export const modelCenter = {
    title: '高效价比的,模型服务',
    desc: '预置全系列文心大模型与上百个精选第三方模型，覆盖广泛行业场景',
    list: model,
    btn: [
        {
            id: 0,
            text: '前往模型广场',
            link: process.env.QF_MODEL_CENTER,
            className: 'btn-gradual model-btn',
            trackInfo: {
                'data-track-category': '新官网PC-高效价比的模型服务',
                'data-track-name': 'EMPTY',
                'data-track-value': '前往模型广场',
            },
        },
        {
            id: 1,
            text: '更多AI能力',
            link: 'https://ai.baidu.com/',
            className: 'btn-secondary model-btn',
            trackInfo: {
                'data-track-category': '新官网PC-高效价比的模型服务',
                'data-track-name': 'EMPTY',
                'data-track-value': '更多AI能力',
            },
        },
    ],
};

export const appBuilder = {
    title: '高效易用的大模型应用开发服务',
    title_m: (
        <>
            高效易用的
            <br />
            AI原生应用开发服务
        </>
    ),
    desc: '企业级Agent、RAG应用开发平台，高效、低门槛解决大模型应用落地最后一公里问题',
    descLink: {
        text: '前往应用开发',
        link: 'https://console.bce.baidu.com/ai_apaas/dialogHome',
        trackInfo: {
            'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
            'data-track-name': '文字链',
            'data-track-value': '前往应用开发',
        },
    },
    list: [
        {
            id: 0,
            name: 'Agent智能体',
            icon: require('assets/qianfan/icon-agent.png').default,
            exp: [
                {
                    tit: '能力全',
                    desc: '升级智能体Pro，支持多智能体协同与复杂任务规划，还有自主规划框架，实现快速响应',
                    desc_m: '智能体Pro支持复杂任务规划，自主规划支持快速响应',
                },
                {
                    tit: '效果好',
                    desc: '工具调度、多轮记忆等模块准确率行业领先，搭建真正的企业级Agent',
                    desc_m: '多模块准确率行业领先，搭建真正的企业级Agent',
                },
                {
                    tit: '易上手',
                    desc: '零代码完成创建应用并分发，同时开源API/SDK，支持高效二次开发',
                    desc_m: '零代码创建应用并分发，开源API/SDK，支持二开',
                },
            ],
            btn: [
                {
                    text: '创建Agent应用',
                    link: 'https://console.bce.baidu.com/ai_apaas/dialogHome',
                    trackInfo: {
                        'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                        'data-track-name': 'Agent智能体',
                        'data-track-value': '创建Agent应用',
                    },
                },
            ],
        },
        {
            id: 1,
            name: 'RAG知识问答',
            icon: require('assets/qianfan/icon-rag.png').default,
            exp: [
                {
                    tit: '广拓展',
                    desc: '企业级无限知识存储容量，检索增强支持百度搜索',
                    desc_m: '无限存储容量，支持百度搜索',
                },
                {
                    tit: '高灵活',
                    desc: '开箱效果和性能行业领先，且知识离线入库、在线检索全流程可调可配',
                    desc_m: '开箱效果领先，检索策略配置灵活',
                },
                {
                    tit: '重安全',
                    desc: '企业级 SLA，生产级资源隔离，支持内容安全审核',
                    desc_m: '企业级 SLA，生产级资源隔离',
                },
            ],
            btn: [
                {
                    text: '管理企业知识库',
                    link: 'https://console.bce.baidu.com/ai_apaas/personalSpace/knowledgeBase',
                    trackInfo: {
                        'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                        'data-track-name': 'RAG知识问答',
                        'data-track-value': '管理企业知识库',
                    },
                },
            ],
        },
        {
            id: 2,
            name: '工作流编排',
            icon: require('assets/qianfan/icon-workflow.png').default,
            exp: [
                {
                    tit: '低门槛',
                    desc: '拖拉拽丝滑编排流程，预置百度搜索等官方组件和丰富的节点',
                    desc_m: '丝滑拖拽编排，节点组件丰富',
                },
                {
                    tit: '能力强',
                    desc: '灵活接入业务系统、编排业务流程，支持多轮对话编排、多模态文件处理',
                    desc_m: '灵活编排多轮对话，处理多模态文件',
                },
                {
                    tit: '效率高',
                    desc: '测试数据便捷复用，调试参数深入完整，多版本高效追溯',
                    desc_m: '调试便捷，多版本高效追溯',
                },
            ],
            btn: [
                {
                    text: '编排业务工作流',
                    link: 'https://console.bce.baidu.com/ai_apaas/componentCenter',
                    trackInfo: {
                        'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                        'data-track-name': '工作流编排',
                        'data-track-value': '编排业务工作流',
                    },
                },
            ],
        },
    ],
};

export const application = {
    title: '开放先进的大模型服务开发全流程',
    title_m: (
        <>
            开放先进的
            <br />
            大模型服务开发全流程
        </>
    ),
    desc: '文心大模型企业级服务唯一入口，提供高可用及高效价比的生成式AI服务及全流程模型开发工具链',
    descLink: {
        text: '前往模型开发',
        link: 'https://console.bce.baidu.com/qianfan/overview',
        trackInfo: {
            'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
            'data-track-name': '文字链',
            'data-track-value': '前往模型开发',
        },
    },
    list: [
        {
            name: '大模型推理',
            icon: require('assets/qianfan/icon-inference.png').default,
            exp: [
                {
                    tit: '更安全',
                    desc: '支持加密传输，具备模型及内容安全等多重防护策略',
                    desc_m: '支持加密传输等多重防护策略',
                },
                {
                    tit: '更易用',
                    desc: '直接调用API或SDK进行业务集成',
                    desc_m: '直接调用API或SDK进行业务集成',
                },
                {
                    tit: '更稳定',
                    desc: '监控实时调用数据，确保服务稳定',
                    desc_m: '监控实时调用数据，确保服务稳定',
                },
            ],
            btn: [
                {
                    text: '在线体验',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineTest',
                    trackInfo: {
                        'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                        'data-track-name': '大模型推理',
                        'data-track-value': '在线体验',
                    },
                },
                {
                    text: '使用推理服务',
                    link: 'https://console.bce.baidu.com/qianfan/ais/console/onlineService',
                    trackInfo: {
                        'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                        'data-track-name': '大模型推理',
                        'data-track-value': '使用推理服务',
                    },
                },
            ],
        },
        {
            name: '大模型精调',
            icon: require('assets/qianfan/icon-sft.png').default,
            exp: [
                {
                    tit: '更高质',
                    desc: '多维度数据洞察与处理，打造高质量数据',
                    desc_m: '多维度数据分析，打造高质量数据',
                },
                {
                    tit: '更精准',
                    desc: '提供Post-pretrain、SFT、以及多种偏好学习训练方法，灵活调整训练参数显著提升效果',
                    desc_m: '丰富的精调训练，灵活调参提升效果',
                },
                {
                    tit: '更智能',
                    desc: '支持人工或自动评估模型效果',
                    desc_m: '可人工或自动评估模型效果',
                },
            ],
            btn: [
                {
                    text: '使用SFT',
                    link: 'https://console.bce.baidu.com/qianfan/train/ft/new?devType=1',
                    trackInfo: {
                        'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                        'data-track-name': '大模型精调',
                        'data-track-value': '使用SFT',
                    },
                },
                {
                    text: '使用Post-pretrain',
                    link: 'https://console.bce.baidu.com/qianfan/train/ft/new?devType=4',
                    trackInfo: {
                        'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                        'data-track-name': '大模型精调',
                        'data-track-value': '使用Post-pretrain',
                    },
                },
            ],
        },
        {
            name: '模型一站式开发',
            icon: require('assets/qianfan/icon-ai.png').default,
            exp: [
                {
                    tit: '更灵活',
                    desc: '稳定的交互式编程环境，支持在线及SSH的编译、调试和模型开发',
                    desc_m: '可在线及SSH编译、调试和开发',
                },
                {
                    tit: '更高效',
                    desc: '预置AIAK-Training、Megatron等加速镜像，支持大规模分布式训练',
                    desc_m: '预置加速镜像，支持分布式训练',
                },
                {
                    tit: '更全面',
                    desc: '预置精选大模型案例，可一键发起，支持白盒训练',
                    desc_m: '预置大模型案例，支持白盒训练',
                },
            ],
            btn: [
                {
                    text: 'Notebook',
                    link: 'https://console.bce.baidu.com/bml/0/project/notebook/list/paddle',
                    trackInfo: {
                        'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                        'data-track-name': '全功能AI开发',
                        'data-track-value': 'Notebook',
                    },
                },
                {
                    text: '作业建模',
                    link: 'https://console.bce.baidu.com/bml/0/project/job/list/preSetCase',
                    trackInfo: {
                        'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                        'data-track-name': '全功能AI开发',
                        'data-track-value': '作业建模',
                    },
                },
            ],
        },
    ],
};

export const practice = {
    title: '最佳应用实践辅助大模型落地',
    titleMobile: (
        <>
            最佳应用实践
            <br />
            辅助大模型落地
        </>
    ),
    desc: '一站式场景需求解析，基于文心大模型实现应用开发，效果评估全流程',
    descMobile: (
        <>
            一站式场景需求解析，基于文心大模型实现应用开发，
            <br />
            效果评估全流程
        </>
    ),
    navTitle: [
        {
            name: '在线教育',
            id: 'onlineEducation',
            trackInfo: {
                'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                'data-track-name': '第1个tab',
                'data-track-value': '在线教育',
            },
        },
        {
            name: '营销电商',
            id: 'marketingEcommerce',
            trackInfo: {
                'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                'data-track-name': '第2个tab',
                'data-track-value': '营销电商',
            },
        },
        {
            name: '社交文娱',
            id: 'socialentertain',
            trackInfo: {
                'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                'data-track-name': '第3个tab',
                'data-track-value': '社交文娱',
            },
        },
        {
            name: '智能硬件',
            id: 'intelligentHardware',
            trackInfo: {
                'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                'data-track-name': '第4个tab',
                'data-track-value': '智能硬件',
            },
        },
        {
            name: '企业服务',
            id: 'enterpriseService',
            trackInfo: {
                'data-track-category': '新官网PC-开放先进的大模型服务开发全流程',
                'data-track-name': '第5个tab',
                'data-track-value': '企业服务',
            },
        },
    ],
    content: {
        onlineEducation: [
            {
                tit: '数学判题',
                id: 'math-judge',
                content: {
                    tit: '数学判题',
                    icon: require('assets/qianfan/practice/scene1_1_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene1_1_bg.png').default,
                    // eslint-disable-next-line max-len
                    des: '在线教育中，判定学生数学答案会考察解题步骤、方法和答案的准确性。大模型同样可以扮演数学题目评判专家的角色。通过精确设定评分标准和模型的训练，大模型可以根据设定的要求对学生的数学答案进行准确评判。',
                    tag: '数学推理',
                    t1: '场景方案',
                    d1: ['提示词工程', '模型精调', 'OCR组件'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '场景最佳实践',
                            p2: '数学判题',
                            link: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Nlzkmgl6q',
                        },
                        {
                            p1: '精调样板',
                            p2: '数学判题',
                            link: 'https://console.bce.baidu.com/qianfan/train/scene/overview/ts-n4xxv5aaghhs',
                        },
                        {
                            p1: '相关数据集',
                            p2: '数学判题SFT',
                            link: 'https://console.bce.baidu.com/qianfan/data/dataset/ds-syeynswz2yxav8ix/detail',
                        },
                        {
                            p1: '应用体验',
                            p2: '拍照解题',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/5ea385e2-8a5f-4ae6-b86f-34c01efb58b1',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '拍照解题',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/mm11hhwrr',
                        },
                    ],
                },
            },
            {
                tit: '作文点评',
                id: 'homework-check',
                content: {
                    tit: '作文点评',
                    icon: require('assets/qianfan/practice/scene1_2_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene1_2_bg.png').default,
                    // eslint-disable-next-line max-len
                    des: '在线教育场景中，对于学生作文通常我们会从作文的内容是否符合题意、作文结构是否严谨、作文是否存在缺点、扣分项、错别字、错误的修辞手法等方面对我们的作文做出评判，并给我们打出最终的得分。其实大模型也可以成为一名点评专家。',
                    tag: '阅读理解',
                    t1: '场景方案',
                    d1: ['提示词工程', '模型精调', 'OCR组件'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '精调样板',
                            p2: '作文自动点评或批改',
                            link: 'https://console.bce.baidu.com/qianfan/train/scene/overview/ts-wjn9hixfmv0j',
                        },
                        {
                            p1: '相关数据集',
                            p2: '高考作文批改SFT',
                            link: 'https://console.bce.baidu.com/qianfan/data/dataset/ds-553hczysf3um4cc9/detail',
                        },
                        {
                            p1: '应用体验',
                            p2: '作文点评助手',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/934707a2-d8d6-4e64-a26d-b39c8f86d05c',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '作文点评助手',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/Lm11l08hv',
                        },
                    ],
                },
            },
            {
                tit: (
                    <>
                        英语口语
                        <br />
                        练习
                    </>
                ),
                id: 'english-practice',
                content: {
                    tit: '英语口语练习',
                    icon: require('assets/qianfan/practice/scene1_3_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene1_3_bg.png').default,
                    tag: '角色对话',
                    // eslint-disable-next-line max-len
                    des: '在线教育中，口语练习是英语学习的重要部分。我们可以借助大模型的生成式能力，让大模型在对话主题内容下通过一对一的角色扮演来模拟真人的对话。比如，让大模型扮演一位高中老师，与学生在主题下模仿高中老师的口吻和学生对话，同时可以引导话题的进行，或者纠正学生在对话中出现的问题。',
                    t1: '场景方案',
                    d1: ['提示词工程', '模型精调'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '精调样板',
                            p2: '英语口语练习',
                            link: 'https://console.bce.baidu.com/qianfan/train/scene/overview/ts-nb8rdi8dd70m',
                        },
                        {
                            p1: '相关数据集',
                            p2: '英语口语练习SFT',
                            link: 'https://console.bce.baidu.com/qianfan/data/dataset/ds-kqv6utnsw0qyu9u4/detail',
                        },
                    ],
                },
            },
            {
                tit: (
                    <>
                        职业教育
                        <br />
                        题目解析
                    </>
                ),
                id: 'job-content-analysis',
                content: {
                    tit: '职业教育题目解析',
                    icon: require('assets/qianfan/practice/scene1_4_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene1_4_bg.png').default,
                    tag: '试题解析',
                    // eslint-disable-next-line max-len
                    des: '在职业教育中，可以通过大模型实时试题解析，判断大模型是否具备处理此场景任务的能力。针对用户咨询试题，基于百度搜索能力与大模型能力，提供题目答案与题目解析过程。',
                    t1: '场景方案',
                    d1: ['提示词工程', 'Agent自主规划', 'RAG知识检索增强'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '场景最佳实践',
                            p2: '职业教育试题解析',
                            link: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/wlzthp3u3',
                        },
                        {
                            p1: '应用体验',
                            p2: '职业教育试题解析',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/1d09effa-43ff-4f73-8d18-eb73d2c8da42',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '职业教育试题解析',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/2m17lsgw4',
                        },
                        {
                            p1: '应用体验',
                            p2: '驾考出题-红灯停停停',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/afb4cda2-b667-4863-ab1a-99f35036c067',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '红灯停停停',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/Um179g1er',
                        },
                    ],
                },
            },
        ],
        marketingEcommerce: [
            {
                tit: (
                    <>
                        客服对话
                        <br />
                        多标签生成
                    </>
                ),
                id: 0,
                content: {
                    tit: '客服对话多标签生成',
                    icon: require('assets/qianfan/practice/scene2_1_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene2_1_bg.png').default,
                    tag: '意图识别',
                    // eslint-disable-next-line max-len
                    des: '在客服对话场景中，可以通过大模型分析用户与客服之间的对话信息，准确识别用户的意图和对应原因，生成对应标签为后续回复和营销策略服务。',
                    t1: '场景方案',
                    d1: ['提示词工程', '模型精调', 'Agent自主规划'],
                    t2: '解决方案样板间',
                    d2: [
                        // {
                        //     p1: '场景最佳实践',
                        //     p2: '客服对话标签',
                        //     link: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/km10jlu3v'
                        // },
                        {
                            p1: '模型精调',
                            p2: '客服对话多标签生成',
                            link: 'https://console.bce.baidu.com/qianfan/train/scene/overview/ts-wrtklq5aj8ih',
                        },
                        {
                            p1: '相关数据集',
                            p2: '客服对话多标签生成SFT',
                            link: 'https://console.bce.baidu.com/qianfan/data/dataset/ds-scm8g98a7pv3zzf3/detail',
                        },
                        {
                            p1: '应用体验',
                            p2: '客服会话总结',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/0dc0a33e-2ceb-4f33-84a5-327fa8789ca6',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '客服会话总结',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/am17nt2xu',
                        },
                    ],
                },
            },
            {
                tit: (
                    <>
                        购物平台
                        <br />
                        客服对话摘要
                    </>
                ),
                id: 1,
                content: {
                    tit: '购物平台客服对话摘要',
                    icon: require('assets/qianfan/practice/scene2_2_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene2_2_bg.png').default,
                    tag: '对话摘要',
                    // eslint-disable-next-line max-len
                    des: '在购物平台上，顾客通常会咨询平台的商品。比如咨询商品的用途、价格，让平台推荐商品等。我们可以借助大模型的生成能力抽取顾客咨询问题的类别、顾客对客户回答的满意度等等，进而做进一步分析。',
                    t1: '场景方案',
                    d1: ['提示词工程', '模型精调'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '精调样板',
                            p2: '购物平台客服对话摘要',
                            link: 'https://console.bce.baidu.com/qianfan/train/scene/overview/ts-s2t9hnbmx7yw',
                        },
                        {
                            p1: '相关数据集',
                            p2: '购物平台客服对话摘要SFT',
                            link: 'https://console.bce.baidu.com/qianfan/data/dataset/ds-1j390abu4fv5abkf/detail',
                        },
                    ],
                },
            },
            {
                tit: (
                    <>
                        营销
                        <br />
                        文案生成
                    </>
                ),
                id: 2,
                content: {
                    tit: '营销文案生成',
                    icon: require('assets/qianfan/practice/scene2_3_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene2_3_bg.png').default,
                    tag: '风格写作',
                    // eslint-disable-next-line max-len
                    des: '在电商营销场景中，可以通过大模型对具体商品进行营销文案编写，极大提高电商运营效率。',
                    t1: '场景方案',
                    d1: ['提示词工程', 'Agent自主规划'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '组件',
                            p2: '风格转写',
                            link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/style_rewrite/detail',
                        },
                        {
                            p1: '组件',
                            p2: '风格写作',
                            link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/style_writing/detail',
                        },
                        {
                            p1: '应用体验',
                            p2: '文案大师',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/5edc2273-eb35-4762-867f-bdfbf46dc10d',
                        },
                    ],
                },
            },
            {
                tit: '评论互动',
                id: 3,
                content: {
                    tit: '评论互动',
                    icon: require('assets/qianfan/practice/scene2_4_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene2_4_bg.png').default,
                    tag: '工作流组件',
                    // eslint-disable-next-line max-len
                    des: '在客服平台上，经常需要跳转不同的客服角色来解答问题，快速有效地总结会话内容，提取客户要点是智能客服平台的常见常见。以旅游场景举例，有的民宿小店客服要负责消费者评价询问的回复，例如，回答用户问题、产品介绍、售后解释等',
                    t1: '场景方案',
                    d1: ['提示词工程', 'RAG知识检索增强', 'Agent自主规划'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '应用体验',
                            p2: '专业评论回复-民宿',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/0347701c-ca09-4524-9725-48e1334e1258',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '专业评论回复-民宿',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/dm181dzbv',
                        },
                    ],
                },
            },
            // {
            //     tit: (
            //         <>
            //             网购决策
            //             <br />
            //             因子分析
            //         </>
            //     ),
            //     id: 4,
            //     content: {
            //         tit: '网购决策因子分析',
            //         icon: require('assets/qianfan/practice/scene2_5_icon.png').default,
            //         sceneBg: require('assets/qianfan/practice/scene2_5_bg.png').default,
            //         tag: '决策因子、精准营销',
            //         // eslint-disable-next-line max-len
            //         des: '根据用户反馈、评论、提问的高频问题进行分析，对应到决策因子的三级类目，进而分析用户在购买过程中的影响购买决策的要素和权重，指导后续运营策略和顾客的精准营销',
            //         t1: '场景方案',
            //         d1: ['提示词工程', 'RAG知识检索增强'],
            //         t2: '解决方案样板间',
            //         d2: [
            //             {
            //                 p1: '场景最佳实践',
            //                 p2: '网购决策因子分析',
            //                 link: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Tm0ex3lpw'
            //             }
            //         ]
            //     }
            // }
        ],
        socialentertain: [
            {
                tit: (
                    <>
                        文本创作
                        <br />
                        字数控制
                    </>
                ),
                id: 0,
                content: {
                    tit: '文本创作字数控制',
                    icon: require('assets/qianfan/practice/scene3_1_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene3_1_bg.png').default,
                    tag: '指令遵循',
                    // eslint-disable-next-line max-len
                    des: '文本创作字数控制场景中，大模型可以扮演高效的写作助手的角色。其具备出色的文本理解、生成及编辑能力，通过精确设定的评分标准和模型精调，大模型可以根据设定的字数要求，生成精准且符合主题的内容。',
                    t1: '场景方案',
                    d1: ['提示词工程', '模型精调'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '精调样板',
                            p2: '文本创作字数控制',
                            link: 'https://console.bce.baidu.com/qianfan/train/scene/overview/ts-hfb9higfzxie',
                        },
                        {
                            p1: '相关数据集',
                            p2: '文本创作字数控制SFT',
                            link: 'https://console.bce.baidu.com/qianfan/data/dataset/ds-sjv3xchndftmg2fu/detail',
                        },
                    ],
                },
            },
            {
                tit: (
                    <>
                        小说人物
                        <br />
                        角色扮演
                    </>
                ),
                id: 1,
                content: {
                    tit: '小说人物角色扮演',
                    icon: require('assets/qianfan/practice/scene3_2_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene3_2_bg.png').default,
                    tag: '角色扮演',
                    // eslint-disable-next-line max-len
                    des: '大模型角色扮演，本质上是让大模型扮演某个特定角色与用户对话，比如扮演西游记中的孙悟空。在游戏、小说场景，通过SFT调优大模型可以为用户带来更符合角色设定的对话体验。',
                    t1: '场景方案',
                    d1: ['提示词工程', '模型精调'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '场景最佳实践',
                            p2: '角色对话',
                            link: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/Ilz0vk93s',
                        },
                        {
                            p1: '精调样板',
                            p2: '小说人物角色扮演',
                            link: 'https://console.bce.baidu.com/qianfan/train/scene/overview/ts-0fg0k99sgw4h',
                        },
                        {
                            p1: '相关数据集',
                            p2: '小说人物角色扮演SFT',
                            link: 'https://console.bce.baidu.com/qianfan/data/dataset/ds-pt19ixpeqrhtgc92/detail',
                        },
                    ],
                },
            },
        ],
        intelligentHardware: [
            {
                tit: '内容资讯',
                id: 0,
                content: {
                    tit: '内容资讯',
                    icon: require('assets/qianfan/practice/scene4_1_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene4_1_bg.png').default,
                    tag: '知识问答、聊天沟通',
                    // eslint-disable-next-line max-len
                    des: '在智能硬件领域，大模型能力赋能内容资讯，实现个性化交互体验。模拟真人对话，精准解答疑问，引导深入探讨，无论是知识获取，聊天沟通，都能让用户享受如面对面的高效交流。',
                    t1: '场景方案',
                    d1: ['提示词工程', 'RAG知识检索增强'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '应用体验',
                            p2: '新闻资讯助手',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/b25ffcfb-ad93-44ca-847c-e83bfde398b4',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '新闻资讯助手',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/9m17ldg1p',
                        },
                        {
                            p1: '应用体验',
                            p2: '医疗智能问答助手',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/32522e3e-179e-41ad-82ed-26a397a3d950',
                        },
                    ],
                },
            },
            {
                tit: '实用工具',
                id: 1,
                content: {
                    tit: '实用工具',
                    icon: require('assets/qianfan/practice/scene4_2_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene4_2_bg.png').default,
                    tag: '知识问答，逻辑推理',
                    // eslint-disable-next-line max-len
                    des: '在智能硬件中，需要借助更多的实用工具实现智能控制与问答，比如查询天气，语言翻译，健康陪伴，人设对话。',
                    t1: '场景方案',
                    d1: ['提示词工程', 'RAG知识检索增强', 'Agent自主规划'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '应用体验',
                            p2: '翻译专家',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/b8809409-3642-4068-b439-15ebb2362927',
                        },
                        {
                            p1: '应用体验',
                            p2: '英语陪聊',
                            link: 'https://appbuilder.baidu.com/s/H8sh3',
                        },
                        {
                            p1: '应用体验',
                            p2: '智家超级管家',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/0a65f254-615c-409f-9a77-eca72199d827',
                        },
                    ],
                },
            },
            {
                tit: '陪读陪伴',
                id: 2,
                content: {
                    tit: '陪读陪伴',
                    icon: require('assets/qianfan/practice/scene4_3_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene4_3_bg.png').default,
                    tag: '图像识别、工作流组件',
                    // eslint-disable-next-line max-len
                    des: '面向陪读陪伴场景的硬件设备，提供人设对话、教育培训，心理健康等应用，提高硬件的交互体验，丰富内容生态。',
                    t1: '场景方案',
                    d1: ['提示词工程', 'RAG知识检索增强', 'Agent自主规划'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '应用体验',
                            p2: '爱因斯坦',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/1058ade8-a030-406b-bdf3-674aabd5bdf8',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '爱因斯坦',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/hm17kc2zd',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '傲娇华妃',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/em17kx0op',
                        },
                        {
                            p1: '应用体验',
                            p2: '国家博物馆数字讲解员',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/3d9a25d7-e59c-4d50-a9e0-a641a2461955',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '国家博物馆数字讲解员',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/0m17jp1fy',
                        },
                    ],
                },
            },
        ],
        enterpriseService: [
            {
                tit: (
                    <>
                        结构化
                        <br />
                        信息提取
                    </>
                ),
                id: 0,
                content: {
                    tit: '结构化信息提取',
                    icon: require('assets/qianfan/practice/scene5_1_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene5_1_bg.png').default,
                    tag: '图像识别、工作流组件',
                    // eslint-disable-next-line max-len
                    des: '以提取出租车票为例，展示OCR+大模型结合后，极大地提高了数据处理的效率和准确性，实现应用开发的扩展性。案例展示出租车发票「发票抬头、发票代码、发票号码、出租车单位、电话、车牌号、日期、时间、单价、里程、实收金额」信息，并以JSON格式输出。',
                    t1: '场景方案',
                    d1: ['提示词工程', '工作流组件', 'Agent自主规划'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '应用体验',
                            p2: '图片结构化信息提取',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/2d17c39c-90d4-4ed5-bfba-909f5fdb82bd',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '图片结构化信息提取',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/Wm11mzmp3',
                        },
                    ],
                },
            },
            {
                tit: (
                    <>
                        智能图片
                        <br />
                        标签生成器
                    </>
                ),
                id: 1,
                content: {
                    tit: '智能图片标签生成器',
                    icon: require('assets/qianfan/practice/scene5_2_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene5_2_bg.png').default,
                    tag: '图像识别、工作流组件',
                    // eslint-disable-next-line max-len
                    des: '在社交媒体平台，自有业务系统中，通过先进的图像识别技术，对上传的图片内容进行智能分析，快速准确地识别出图片中的主要元素和特征，随后基于这些识别结果，自动生成与该图片内容相关性最高的5个标签，以便于用户更好地分类、搜索和组织图片，同时提升图片的检索效率和用户体验。',
                    t1: '场景方案',
                    d1: ['提示词工程', '工作流组件', 'Agent自主规划'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '应用体验',
                            p2: '智能图片标签生成器',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/86d33119-df82-42cb-a9e8-7c3a1385e1a8',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '图片标签生成',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/86d33119-df82-42cb-a9e8-7c3a1385e1a8',
                        },
                    ],
                },
            },
            {
                tit: '企业招聘',
                id: 2,
                content: {
                    tit: '企业招聘',
                    icon: require('assets/qianfan/practice/scene5_3_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene5_3_bg.png').default,
                    tag: '人岗匹配',
                    // eslint-disable-next-line max-len
                    des: '大模型在人岗匹配中的应用通过智能化算法和大数据分析，帮助企业更高效地筛选和匹配候选人。它不仅可以分析求职者的简历和职业经历，还能够理解职位需求，提取岗位的核心要求。通过自然语言处理技术，大模型能精准解读候选人的技能、经验和职业倾向，并将其与职位要求进行智能匹配。同时，它还能评估候选人与公司文化的契合度，提供更全面的人岗匹配建议，帮助HR优化招聘流程，提升招聘成功率。',
                    t1: '场景方案',
                    d1: ['提示词工程', '模型精调'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '场景最佳实践',
                            p2: '面试题生成',
                            link: 'https://cloud.baidu.com/doc/WENXINWORKSHOP/s/glzc3y0lw',
                        },
                        {
                            p1: '应用体验',
                            p2: '企业招聘智能助手',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/8299194c-6b67-489b-8677-8cab7e8acb63',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '企业招聘智能助手',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/zm17tmf87',
                        },
                    ],
                },
            },
            {
                tit: (
                    <>
                        企业知识
                        <br />
                        助手
                    </>
                ),
                id: 3,
                content: {
                    tit: '企业知识助手',
                    icon: require('assets/qianfan/practice/scene5_4_icon.png').default,
                    sceneBg: require('assets/qianfan/practice/scene5_4_bg.png').default,
                    tag: '知识问答',
                    // eslint-disable-next-line max-len
                    des: '大模型在企业专业知识问答上发挥着提升信息检索效率、实现深度问答、自动化文档处理、个性化推荐、辅助决策支持、优化知识管理等多重作用。案例展示港口，电力行业的知识管理类应用场景。',
                    t1: '场景方案',
                    d1: ['提示词工程', 'RAG知识检索增强'],
                    t2: '解决方案样板间',
                    d2: [
                        {
                            p1: '应用体验',
                            p2: '港口司机服务助手',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/41e384eb-bc6d-4f2e-9629-950d6cd22267',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '港口司机服务助手',
                            link: 'ttps://cloud.baidu.com/doc/AppBuilder/s/Sm17b6hm1',
                        },
                        {
                            p1: '应用体验',
                            p2: '电力知识库助手',
                            link: 'https://console.bce.baidu.com/ai_apaas/examplePage/b490ec71-2480-4ac9-9748-91e77902e239',
                        },
                        {
                            p1: '应用最佳实践',
                            p2: '电力知识库助手',
                            link: 'https://cloud.baidu.com/doc/AppBuilder/s/Tm17t5e5x',
                        },
                    ],
                },
            },
        ],
    },
};

export const resource = {
    title: '全面的AI开发资源',
    desc: '汇集丰富的大模型开发技巧、实践案例、文档资料，提供答疑互助支持',
    descLink: {
        text: '前往千帆AI应用开发者中心',
        link: 'https://cloud.baidu.com/qianfan/dev_center/home',
        trackInfo: {
            'data-track-category': '新官网PC-全面的AI开发资源',
            'data-track-name': '文字链',
            'data-track-value': '前往千帆AI应用开发者中心',
        },
    },
    list: [
        {
            name: '模型开发资源',
            exp: [
                {label: '模型列表', link: 'https://cloud.baidu.com/doc/qianfan-docs/s/7m95lyy43'},
                {label: 'Github开源', link: 'https://github.com/baidubce/bce-qianfan-sdk'},
                {label: 'API文档', link: 'https://cloud.baidu.com/doc/qianfan-api/s/3m9b5lqft'},
                {label: '最佳实践', link: 'https://cloud.baidu.com/qianfan/dev_center/practices'},
            ],
        },
        {
            name: '应用开发资源',
            exp: [
                {label: '核心概念', link: 'https://cloud.baidu.com/doc/qianfan-docs/s/tm983fszw'},
                {label: 'Github开源', link: 'https://github.com/baidubce/app-builder'},
                {label: 'API文档', link: 'https://cloud.baidu.com/doc/qianfan-api/s/Nm7vrwe2k'},
                {label: '最佳实践', link: 'https://cloud.baidu.com/qianfan/dev_center/practices'},
            ],
        },
    ],
};

export const scene = {
    application: [
        {
            icon: require('assets/qianfan/apply/apply1.png').default,
            text: '拍照解题',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/5ea385e2-8a5f-4ae6-b86f-34c01efb58b1',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            icon: require('assets/qianfan/apply/apply2.png').default,
            text: '作文点评助手',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/934707a2-d8d6-4e64-a26d-b39c8f86d05c',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            icon: require('assets/qianfan/apply/apply3.png').default,
            text: '智课辅导小助手',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/5a5289d8-20fe-46b7-9f4f-1db1801592c1',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            icon: require('assets/qianfan/apply/apply4.png').default,
            text: '图像结构化信息提取',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/2d17c39c-90d4-4ed5-bfba-909f5fdb82bd',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            icon: require('assets/qianfan/apply/apply4_1.png').default,
            text: '电力知识库助手',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/b490ec71-2480-4ac9-9748-91e77902e239',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 5,
            icon: require('assets/qianfan/apply/apply5.png').default,
            text: '企业招聘智能助手',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/8299194c-6b67-489b-8677-8cab7e8acb63',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 6,
            icon: require('assets/qianfan/apply/apply6.png').default,
            text: '中差评识别及干预',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/d330de29-e447-4eb8-ba27-839fa888c475',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 7,
            icon: require('assets/qianfan/apply/apply7.png').default,
            text: '智能客服-会话总结',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/0dc0a33e-2ceb-4f33-84a5-327fa8789ca6',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 7,
            icon: require('assets/qianfan/apply/apply7_1.png').default,
            text: '私人茶叶销售助手',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/115dec44-6bff-43bc-b60b-3b107042ab82',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 7,
            icon: require('assets/qianfan/apply/apply8.png').default,
            text: '新闻资讯助手',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/b25ffcfb-ad93-44ca-847c-e83bfde398b4',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 8,
            icon: require('assets/qianfan/apply/apply8_1.png').default,
            text: '试题信息抽取',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/0f968193-5d18-48cc-ab1e-2b84af8ccf56',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 13,
            icon: require('assets/qianfan/apply/apply13.png').default,
            text: '爱因斯坦',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/1058ade8-a030-406b-bdf3-674aabd5bdf8',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        // {
        //     id: 9,
        //     icon: require('assets/qianfan/apply/apply9.png').default,
        //     text: '医学智能问答助手',
        //     btn: {
        //         text: '在线体验',
        //         link: 'https://console.bce.baidu.com/ai_apaas/examplePage/32522e3e-179e-41ad-82ed-26a397a3d950',
        //         trackInfo: {
        //             'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
        //             'data-track-name': '按钮',
        //             'data-track-value': '在线体验'
        //         }
        //     }
        // },
        {
            id: 10,
            icon: require('assets/qianfan/apply/apply10.png').default,
            text: '图片诗意描述器',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/c0c4a136-e1c3-4072-a2b7-1ed43ed7ea0d',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 11,
            icon: require('assets/qianfan/apply/apply11.png').default,
            text: '智能图片标签生成器',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/86d33119-df82-42cb-a9e8-7c3a1385e1a8',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 12,
            icon: require('assets/qianfan/apply/apply12.png').default,
            text: '职业教育试题解析助教',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/examplePage/1d09effa-43ff-4f73-8d18-eb73d2c8da42',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
    ],
    assembly: [
        {
            id: 0,
            icon: require('assets/qianfan/assembly/assembly0.png').default,
            text: '百度搜索',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/web_search/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 1,
            icon: require('assets/qianfan/assembly/assembly1.png').default,
            text: '代码解释器',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/code_interpreter/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 2,
            icon: require('assets/qianfan/assembly/assembly2.png').default,
            text: '文生图',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/image/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 21,
            icon: require('assets/qianfan/assembly/assembly21.png').default,
            text: '图像内容理解',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/image_understand/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 4,
            icon: require('assets/qianfan/assembly/assembly3.png').default,
            text: '通用文字识别-高精度版',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/general_ocr/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 5,
            icon: require('assets/qianfan/assembly/assembly4.png').default,
            text: '天气查询',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/weather_query/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 6,
            icon: require('assets/qianfan/assembly/assembly5.png').default,
            text: '短语音识别-极速版',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/asr/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 7,
            icon: require('assets/qianfan/assembly/assembly6.png').default,
            text: '快递查询',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/query_express_package/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 15,
            icon: require('assets/qianfan/assembly/assembly14.png').default,
            text: '短文本在线合成',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/tts_high/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 8,
            icon: require('assets/qianfan/assembly/assembly7.png').default,
            text: '手写文字识别',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/handwrite_ocr/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 14,
            icon: require('assets/qianfan/assembly/assembly13.png').default,
            text: '网页内容总结',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/web_summary/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 9,
            icon: require('assets/qianfan/assembly/assembly8.png').default,
            text: '热门视频',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/video_get/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 10,
            icon: require('assets/qianfan/assembly/assembly9.png').default,
            text: 'iRAG图片生成',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/i_rag/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 11,
            icon: require('assets/qianfan/assembly/assembly10.png').default,
            text: '图生视频',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/image_to_video/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 12,
            icon: require('assets/qianfan/assembly/assembly11.png').default,
            text: '文本翻译-通用版',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/translate/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
        {
            id: 13,
            icon: require('assets/qianfan/assembly/assembly12.png').default,
            text: '图生视频-模板增强',
            btn: {
                text: '在线体验',
                link: 'https://console.bce.baidu.com/ai_apaas/componentCenter/image_to_video_scene/detail',
                trackInfo: {
                    'data-track-category': '新官网PC-高效易用的AI原生应用开发服务',
                    'data-track-name': '按钮',
                    'data-track-value': '在线体验',
                },
            },
        },
    ],
};

export const cooperation = {
    title: '与全球伙伴携手，深入产业共创价值',
    list: [
        {
            id: 1,
            icon: require('assets/qianfan/partner/partner_1.png').default,
        },
        {
            id: 2,
            icon: require('assets/qianfan/partner/partner_2.png').default,
        },
        {
            id: 3,
            icon: require('assets/qianfan/partner/partner_3.png').default,
        },
        {
            id: 4,
            icon: require('assets/qianfan/partner/partner_4.png').default,
        },
        {
            id: 5,
            icon: require('assets/qianfan/partner/partner_5.png').default,
        },
        {
            id: 6,
            icon: require('assets/qianfan/partner/partner_6.png').default,
        },
        {
            id: 7,
            icon: require('assets/qianfan/partner/partner_7.png').default,
        },
        {
            id: 8,
            icon: require('assets/qianfan/partner/partner_8.png').default,
        },
        {
            id: 9,
            icon: require('assets/qianfan/partner/partner_9.png').default,
        },
        {
            id: 10,
            icon: require('assets/qianfan/partner/partner_10.png').default,
        },
        {
            id: 11,
            icon: require('assets/qianfan/partner/partner_11.png').default,
        },
        {
            id: 12,
            icon: require('assets/qianfan/partner/partner_12.png').default,
        },
        {
            id: 13,
            icon: require('assets/qianfan/partner/partner_13.png').default,
        },
        {
            id: 14,
            icon: require('assets/qianfan/partner/partner_14.png').default,
        },
        {
            id: 15,
            icon: require('assets/qianfan/partner/partner_15.png').default,
        },
        {
            id: 16,
            icon: require('assets/qianfan/partner/partner_16.png').default,
        },
    ],
};
